import { render, staticRenderFns } from "./Intolerance.vue?vue&type=template&id=2125c499&"
import script from "./Intolerance.vue?vue&type=script&lang=js&"
export * from "./Intolerance.vue?vue&type=script&lang=js&"
import style0 from "./Intolerance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports